import React from 'react';
import { motion } from 'framer-motion';
import './Quotes.css';

/*
 * ==============================================
 * HOW TO EDIT (via Claude chat):
 * ==============================================
 * "Add a new quote: 'The only way to do great work...' by Steve Jobs"
 * "Add a writeup titled 'On Perseverance' with this text: ..."
 */

const quotes = [
  {
    id: 1,
    text: 'Chummy Chum will live forever and continue to do his job for generations to come.',
    author: 'Ramesh Genomal',
    color: 'var(--color-accent)',
  },
  {
    id: 2,
    text: 'This is the Charity of Love — unconditional love that comes from your heart. Charity that is profound and discreet.',
    author: 'Chummy Chum Foundation Philosophy',
    color: 'var(--color-accent-purple)',
  },
  {
    id: 3,
    text: 'It\'s not the kind of institutional charity that donates funds, used clothes or goods to charity organizations. This is a different kind of charity.',
    author: 'Ramesh Genomal, on the Chummy Chum Foundation',
    color: 'var(--color-accent)',
  },
  // === ADD MORE QUOTES ABOVE ===
];

const writeups = [
  {
    id: 1,
    title: 'On the Charity of Love',
    content: 'The Chummy Chum Foundation is a very unfamiliar and unique kind of charity. We call it the "Charity of Love" — unconditional love that comes from your heart and charity that is profound and discreet. We do not solicit donations. We do not seek recognition. We simply show up, week after week, year after year, with love for children who need it most. This is what I believe charity should truly be.',
    date: '2007',
  },
  {
    id: 2,
    title: 'A Promise to the Next Generation',
    content: 'Chummy Chum will live forever and continue to do his job for generations to come. This is not just my promise — it is the commitment of my wife and our three sons, who are all personally involved in the foundation. We believe that the most powerful legacy you can leave is not wealth or buildings, but the love you gave to those who needed it most.',
    date: 'A Family Commitment',
  },
  // === ADD MORE WRITEUPS ABOVE ===
];

function Quotes() {
  return (
    <section className="quotes section-padding" id="quotes">
      <div className="container">
        <motion.div
          className="quotes__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Words That Matter</span>
          <h2 className="section-title">
            Quotes & writeups<br />
            <span className="text-gradient">collected through the years</span>
          </h2>
        </motion.div>

        {/* Quotes Grid */}
        <div className="quotes__grid">
          {quotes.map((quote, i) => (
            <motion.div
              key={quote.id}
              className="quotes__card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * i }}
              whileHover={{ y: -4, transition: { duration: 0.3 } }}
            >
              <div className="quotes__mark" style={{ color: quote.color }}>"</div>
              <p className="quotes__text">{quote.text}</p>
              <span className="quotes__author">— {quote.author}</span>
              <div className="quotes__glow" style={{ background: quote.color }} />
            </motion.div>
          ))}
        </div>

        {/* Writeups */}
        {writeups.length > 0 && (
          <div className="quotes__writeups">
            <h3 className="quotes__writeups-title">Writeups & Reflections</h3>
            {writeups.map((writeup, i) => (
              <motion.div
                key={writeup.id}
                className="quotes__writeup"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * i }}
              >
                <div className="quotes__writeup-meta">
                  <h4 className="quotes__writeup-title">{writeup.title}</h4>
                  <span className="quotes__writeup-date">{writeup.date}</span>
                </div>
                <p className="quotes__writeup-content">{writeup.content}</p>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default Quotes;
